<template>
    <div class="row">
        <div id="APITestUpdateModal" class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">Update "{{endpoint.name}}"</p>
            </header>
            <section class="modal-card-body">
                <b-field label="Name">
                    <b-input type="text" v-model="endpoint.name"></b-input>
                </b-field>
                <div class="slider-field-interval" style="width: 550px;">
                    <b-field label="Check interval">
                        <b-slider :min="1" :max="7" :tooltip="false" size="is-large" v-model="endpoint.interval">
                            <b-slider-tick :value="1">1 min</b-slider-tick>
                            <b-slider-tick :value="2">5 min</b-slider-tick>
                            <b-slider-tick :value="3">15 min</b-slider-tick>
                            <b-slider-tick :value="4">30 min</b-slider-tick>
                            <b-slider-tick :value="5">1 hour</b-slider-tick>
                            <b-slider-tick :value="7">24 hours</b-slider-tick>
                        </b-slider>
                    </b-field>
                </div>
            </section>
            <footer class="modal-card-foot" style="text-align: right;">
                <button class="button" type="button" @click="$parent.close()">Close</button>
                <button class="button is-primary" @click="emitEvent">Save</button>
            </footer>
        </div>
    </div>
</template>

<script>
var now = new Date();

let selectedProduct = null;

export default {
    name: 'APITestUpdateModal',
    props:{
        endpoint: Object
    },
    components: {},
    methods:{
        emitEvent: function(){
            this.$emit('updated-test', this.endpoint);
            this.$parent.close()
        },
    },
    mounted: function(){}
}
</script>

<style scoped>
    #APITestUpdateModal >>> .b-slider.is-large .b-slider-tick-label{margin-top: 12px;}
    #APITestUpdateModal .slider-field-interval >>> label{margin-left: -15px; margin-top: 30px;}
    #APITestUpdateModal .slider-field-interval >>> .b-slider-tick-label{margin-top: 13px !important; width: 60px; text-align: center;}
    #APITestUpdateModal .slider-field-interval{
        width: 550px;
        position: relative;
        padding: 0px 20px 20px 20px;
    }
</style>